import React from 'react';
import { houseModels, houseMediaSets } from '../../data/houses';
import Navbar from '../Navbar/Navbar';
import './ProductMediaPage.css';

const ProductMediaPage = () => {
  return (
    <div className="product-media-page">
      <Navbar />

      <main className="product-media-main">
        <header className="product-media-header">
          <h1 className="product-media-title">Product Media Library</h1>
          <p className="product-media-subtitle">
            For each product, add or adjust its images and videos in the media sections below.
          </p>
        </header>

        <div className="product-media-list">
          {houseModels.map((house) => {
            const mediaKey = house.mediaKey || house.id;
            const media = houseMediaSets[mediaKey] || {};
            const mediaEntries = Object.entries(media);

            return (
              <section key={house.id} className="product-media-card">
                <div className="product-media-card-header">
                  <div className="product-media-card-main">
                    <h2 className="product-media-house-title">{house.title}</h2>
                    <p className="product-media-house-meta">
                      ID: <code>{house.id}</code> • Category: {house.productCategory}
                    </p>
                    <p className="product-media-house-description">{house.description}</p>
                  </div>
                  <div className="product-media-house-thumb">
                    <img src={house.image} alt={house.title} />
                  </div>
                </div>

                <div className="product-media-sections">
                  {mediaEntries.length === 0 && (
                    <div className="product-media-empty">
                      No media configured yet. Add entries for this ID in
                      {' '}<code>houseMediaSets</code> inside <code>HouseConfigurator.js</code>.
                    </div>
                  )}

                  {mediaEntries.map(([sectionKey, items]) => (
                    <div key={sectionKey} className="product-media-section">
                      <h3 className="product-media-section-title">
                        {sectionKey.replace(/([A-Z])/g, ' $1').replace(/\b\w/g, (l) => l.toUpperCase())}
                      </h3>
                      <div className="product-media-items-grid">
                        {items.map((item, index) => {
                          const isVideo = item && typeof item === 'object' && item.type === 'video';
                          const src = isVideo ? item.src : item;

                          return (
                            <div key={index} className="product-media-item">
                              <div className="product-media-thumb">
                                {isVideo ? (
                                  <video src={src} controls muted />
                                ) : (
                                  <img src={src} alt={`${house.title} ${sectionKey} ${index + 1}`} />
                                )}
                              </div>
                              <div className="product-media-item-meta">
                                <span className="product-media-item-type">
                                  {isVideo ? 'Video' : 'Image'} #{index + 1}
                                </span>
                                <span className="product-media-item-src">{src}</span>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  ))}
                </div>
              </section>
            );
          })}
        </div>
      </main>
    </div>
  );
};

export default ProductMediaPage;

